import React from 'react';
import { Package, ShoppingCart, Wrench, Briefcase } from 'lucide-react';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ItemTypesGrid,
  ItemTypeButton,
  ItemTypeIcon,
  ItemTypeTitle,
  ItemTypeDescription,
  ModalFooter
} from './AddItemModal.style';
import { Button } from './style';

interface AddItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: 'rawMaterial' | 'service' | 'resource' | 'productFinal') => void;
}

const AddItemModal: React.FC<AddItemModalProps> = ({ isOpen, onClose, onSelectType }) => {
  const itemTypes = [
    {
      value: 'rawMaterial' as const,
      label: 'Matéria Prima',
      icon: Package,
      description: 'Materiais base para produção'
    },
    {
      value: 'productFinal' as const,
      label: 'Produto Manufaturado',
      icon: ShoppingCart,
      description: 'Produto acabado'
    },
    {
      value: 'resource' as const,
      label: 'Insumos',
      icon: Wrench,
      description: 'Recursos e ferramentas'
    },
    {
      value: 'service' as const,
      label: 'Serviços',
      icon: Briefcase,
      description: 'Serviços especializados'
    }
  ] as const;

  const handleSelectType = (type: 'rawMaterial' | 'service' | 'resource' | 'productFinal') => {
    onSelectType(type);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>Selecione o tipo de item</ModalTitle>
        <ItemTypesGrid>
          {itemTypes.map((type) => {
            const IconComponent = type.icon;
            return (
              <ItemTypeButton key={type.value} onClick={() => handleSelectType(type.value)}>
                <ItemTypeIcon as={IconComponent} size={32} />
                <ItemTypeTitle>{type.label}</ItemTypeTitle>
                <ItemTypeDescription>{type.description}</ItemTypeDescription>
              </ItemTypeButton>
            );
          })}
        </ItemTypesGrid>
        <ModalFooter>
          <Button variant="danger-outline" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AddItemModal; 